/* src/app/modules/coils/components/coil-detail/coil-detail.component.scss */
* {
  overflow: hidden;
}
:host {
  --functional-green:
    18,
    135,
    46;
  --functional-red:
    200,
    44,
    41;
}
.marker-icon-container {
  display: flex;
  align-items: center;
  margin-bottom: -1rem;
}
.marker-icon-container sh-text {
  margin-left: 0.9rem;
}
sh-card {
  display: block;
  border-bottom: 1rem solid transparent;
}
section div:nth-of-type(1) {
  border-bottom: 1px solid #d3d3d3;
}
.marker-toggle-div {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-right: 1rem;
}
.marker-toggle-div .marker-recommendation {
  margin-left: 3.95rem;
}
.marker-toggle-div sh-toggle {
  align-items: center;
}
.broken-cable-aligment {
  flex-direction: column;
}
.card-wrapper {
  background: red !important;
}
[screen-tablet] :host-context .marker-toggle-div {
  margin-top: -0.5rem;
}
.clickable-coil-label {
  font: var(--header-2);
  margin-left: 0.5rem;
  text-align: center;
}
[screen-phone] :host-context section {
  flex-direction: column;
}
[screen-phone] :host-context section div:nth-of-type(1) {
  flex: 2;
  border-right: none;
  border-bottom: 1px solid #d3d3d3;
  margin-bottom: 1rem;
  width: fit-content;
}
[screen-phone] :host-context .marker-icon-container {
  display: flex;
  align-items: center;
  margin-top: -0.4rem;
  padding-bottom: 1rem;
}
[screen-phone] :host-context .marker-icon-container sh-text {
  margin-left: 0.5rem;
}
[screen-phone] :host-context .marker-toggle-div {
  display: block;
  margin-left: -0.05rem;
  overflow: visible;
}
[screen-phone] :host-context .marker-toggle-div .marker-recommendation {
  margin-left: 3.6rem;
}
[screen-phone] :host-context .marker-toggle-div sh-toggle {
  margin-left: 8.7rem;
}
[screen-phone] :host-context .coil-label-container {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  justify-content: space-between;
}
[screen-phone] :host-context .marker-toggle-div {
  margin-top: -1.5rem;
}
.align-broken-cable {
  display: flex;
  align-items: center;
}
/*# sourceMappingURL=coil-detail.component.css.map */
